import { useParams } from "@tanstack/react-router"
import type { FC } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import { PermissionActionType } from "@/constants/permissions"
import { CommentParentTableType } from "@/graphql/codegen/graphql"
import { usePermissionManager } from "@/hooks/usePermissionManager"

export const GoodsReceiptCommentsTab: FC = () => {
  const { hasPermissions } = usePermissionManager()
  const canMaintain = hasPermissions([PermissionActionType.WAREHOUSE_RECEIVING_MAINTENANCE])

  const { goodsReceiptId } = useParams({ strict: false })

  return (
    <CommentsSection
      type={CommentParentTableType.GoodsReceipt}
      referenceId={goodsReceiptId}
      isReadOnly={!canMaintain}
    />
  )
}
